import { Controller } from "@hotwired/stimulus"

// Kontroler modala wyboru plików z Intum Drive.
// Zaznaczanie wielu plików: klik przełącza pojedynczy plik, Shift zaznacza zakres.
// Przycisk "Dodaj wybrane" emituje zdarzenie do dropzone maila dla każdego zaznaczonego pliku.
export default class extends Controller {
  static targets = ["file", "confirm", "counter"]
  static values = { pickerId: String }

  connect() {
    this.selected = new Set()
    this.lastIndex = null
    this.updateUI()
  }

  // czyści zaznaczenie plików
  reset() {
    this.selected.clear()
    this.lastIndex = null
    this.updateUI()
  }

  // klik w kafelek pliku - przełącza zaznaczenie; Shift zaznacza zakres
  toggle(event) {
    const index = parseInt(event.currentTarget.dataset.index)

    if (event.shiftKey && this.lastIndex != null) {
      // zakres od ostatnio klikniętego do bieżącego (dodaje do zaznaczenia)
      const from = Math.min(this.lastIndex, index)
      const to = Math.max(this.lastIndex, index)
      for (let i = from; i <= to; i++) this.selected.add(i)
    } else {
      // przełącz pojedynczy plik - ponowny klik odznacza
      if (this.selected.has(index)) this.selected.delete(index)
      else this.selected.add(index)
    }

    this.lastIndex = index
    this.updateUI()
  }

  // odświeża podświetlenie kafelków i stan/licznik przycisku "Dodaj wybrane"
  updateUI() {
    this.fileTargets.forEach(el => {
      const on = this.selected.has(parseInt(el.dataset.index))
      // ring-inset - obwódka rysowana do wewnątrz kafelka, żeby overflow-y-auto siatki
      // nie przycinał jej przy krawędzi (np. lewy górny kafelek)
      el.classList.toggle("ring-2", on)
      el.classList.toggle("ring-inset", on)
      el.classList.toggle("ring-blue-500", on)
      el.classList.toggle("bg-blue-50", on)
    })

    const count = this.selected.size
    if (this.hasConfirmTarget) this.confirmTarget.disabled = count === 0
    if (this.hasCounterTarget) {
      const label = this.counterTarget.dataset.label
      this.counterTarget.textContent = count > 0 ? `${label} (${count})` : label
    }
  }

  // emituje zdarzenie dołączenia dla każdego zaznaczonego pliku i czyści wybór
  // (modal zamyka osobna akcja modal#hide). Reset tutaj sprawia, że po ponownym
  // otwarciu modala - który ładuje treść raz (lazy) - nie zostaje stare zaznaczenie
  confirm() {
    this.fileTargets.forEach(el => {
      if (!this.selected.has(parseInt(el.dataset.index))) return

      window.dispatchEvent(new CustomEvent("drive-attachment:add", {
        detail: {
          pickerId: this.pickerIdValue,
          signedId: el.dataset.signedId,
          name: el.dataset.name,
          size: el.dataset.size,
          isImage: el.dataset.isImage,
          url: el.dataset.url,
        },
      }))
    })

    this.reset()
  }
}
